import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cns from 'classnames';
import { getAllSections, getAllSocials, getAllStyle, changeStyleParam, getAllFonts, internalizationState } from '../../../stores/reducers/sections';
import Icon from '../../Icon';
import { getEventKey, getIsAdminLoggedIn } from '../../../stores/reducers/userData';
import Input from './Input/Input';
import Checkbox from './Checkbox/Checkbox';
import Block from './Block/Block';
import SectionsDnd from './SectionsDnd';
import Socials from './Socials';
import './Settings.sass';
import { saveFrontSettings, savePreloadertSettings } from '../../../api';
import LoginModal from '../../Modals/LoginModal/LoginModal';
import { generatePreloader } from '../../Elements/Preloader/generatePreloader';
import { Preloader } from 'src/components/Elements/Preloader/Preloader';
interface SettingsProps {
  className?: string;
}

const fontListOld = [
  'Arial',
  'Futura PT',
  'Roboto',
  'Georgia',
  'Geometria',
  'Gerbera',
  'Open Sans',
  'PT Serif',
  'Circe',
  'Calibri',
  'Circe Rounded',
  'Formular',
  'Mediator Serif Web',
  'Opinion Pro Lt',
  'Reforma Grotesk',
  'Orchidea Pro',
  'Iskra',
  'IntelOne Display',
  'Intel Clear',
];

const Settings: FC<SettingsProps> = () => {
  const styles = useSelector(getAllStyle);
  const socials = useSelector(getAllSocials);
  const sections = useSelector(getAllSections);
  const fonts = useSelector(getAllFonts);
  const dispatch = useDispatch();
  const eventKey = useSelector(getEventKey);
  const [panelOpen, setPanelOpen] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [isPrelShown, setPrelShown] = useState<boolean>(false);
  const isAdminLoggedIn = useSelector(getIsAdminLoggedIn);
  const fontList = fonts ? fonts.map((font) => font.title) : fontListOld;
  const langConfig = useSelector(internalizationState);

  const handlePrelShow = () => setPrelShown((p) => !p);

  const handleStyleUpdate = (value: string | number | boolean, section: any, id: any) => {
    dispatch(changeStyleParam({ value, section, id }));
  };

  const updateHeaderBgBehavior = (value: string) => {
    dispatch(changeStyleParam({ value, section: 'header', id: 'bgBehavior' }));
  };

  useEffect(() => {
    if (isAdminLoggedIn && !panelOpen) {
      const preloaderWithStyles = generatePreloader(styles);

      saveFrontSettings(eventKey, { styles, socials, sections });
      savePreloadertSettings(eventKey, preloaderWithStyles);
    }
  }, [isAdminLoggedIn, panelOpen, eventKey, styles, socials, sections]);

  return (
    <>
      <LoginModal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} isAdminAuth />
      <div
        className={cns('setting-wrapp', panelOpen && 'opened')}
        role="button"
        tabIndex={0}
        onClick={() => setPanelOpen(false)}>
        <div
          className="setting-open-button"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            setPanelOpen(!panelOpen);
          }}>
          <Icon name="setting" />
        </div>
        <div
          className="main-setting"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <div className="main-setting-tt">{langConfig.activeLangState === 'ru' ? 'Настройки' : 'Settings'}</div>
          <Block title={langConfig.activeLangState === 'ru' ? 'Цвета' : 'Colors'} isOpened={false}>
            <ul className="setting-options">
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Основной цвет' : 'Main color'}
                  icon="paint"
                  hex={styles.colors.primary}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'primary')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Дополнительный цвет' : 'Complementary color'}
                  icon="paint"
                  hex={styles.colors.accent}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'accent')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Дополнительный цвет' : 'Complementary color'}
                  icon="paint"
                  hex={styles.colors.extra}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'extra')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Дополнительный цвет' : 'Complementary color'}
                  icon="paint"
                  hex={styles.colors.white}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'white')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет текста' : 'Font color'}
                  icon="paint"
                  hex={styles.colors.font}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'font')}
                />
              </li>
            </ul>
          </Block>
          <Block title={langConfig.activeLangState === 'ru' ? 'Шрифты' : 'Fonts'} isOpened={false}>
            <ul className="setting-options">
              <li>
                <div className="ui-group">
                  <div className="setting-label">{langConfig.activeLangState === 'ru' ? 'Заголовки' : 'Titles'}</div>
                  <div className="setting-field-group">
                    <div className="setting-field">
                      <button type="button" className="setting-field-btn">
                        <Icon name="ch-arr-bottom" />
                      </button>
                      <select
                        className="ui-input"
                        onChange={(e) => handleStyleUpdate(e.target.value, 'fonts', 'headings')}
                        value={styles.fonts.headings}>
                        {fontList.map((font, ind) => (
                          <option key={ind}>{font}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <Input
                  label={langConfig.activeLangState === 'ru' ? 'Размер заголовка' : 'Title size'}
                  value={styles.textSize.header}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'textSize', 'header')}
                />
              </li>

              <li>
                <div className="ui-group">
                  <div className="setting-label">{langConfig.activeLangState === 'ru' ? 'Основной шрифт' : 'Main font'}</div>
                  <div className="setting-field-group">
                    <div className="setting-field">
                      <button type="button" className="setting-field-btn">
                        <Icon name="ch-arr-bottom" />
                      </button>
                      <select
                        className="ui-input"
                        onChange={(e) => handleStyleUpdate(e.target.value, 'fonts', 'main')}
                        value={styles.fonts.main}>
                        {fontList.map((font, ind) => (
                          <option key={ind}>{font}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <Input
                  label={langConfig.activeLangState === 'ru' ? 'Размер Основного шрифта' : 'Main font size'}
                  value={styles.textSize.body}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'textSize', 'body')}
                />
              </li>
              <li>
                <Input
                  label={langConfig.activeLangState === 'ru' ? 'Размер шрифта в меню' : 'Menu font size'}
                  value={styles.textSize.body}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'textSize', 'menu')}
                />
              </li>
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Не уменьшать размер меню при уменьшении ширины сайта' : 'Disable adaptive menu size'}
                  value={styles.textSize.locMenuSize} 
                  handleChange={(e: boolean) => handleStyleUpdate(e, 'textSize', 'locMenuSize')}
                />
              </li>
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Отображать пункты меню заглавными' : 'Capitalize menu link'}
                  value={styles.textSize.capitalizeMenuLink} 
                  handleChange={(e: boolean) => handleStyleUpdate(e, 'textSize', 'capitalizeMenuLink')}
                />
              </li>
            </ul>
          </Block>
          <Block title={langConfig.activeLangState === 'ru' ? 'Скругления' : 'Fillets'} isOpened={false}>
            <ul className="setting-options">
              <li>
                <Input
                  label={langConfig.activeLangState === 'ru' ? 'Большие' : 'Big'}
                  value={styles.roundings.big}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'roundings', 'big')}
                />
              </li>
              <li>
                <Input
                  label={langConfig.activeLangState === 'ru' ? 'Малые' : 'Small'}
                  value={styles.roundings.small}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'roundings', 'small')}
                />
              </li>
            </ul>
          </Block>

          <Block title={langConfig.activeLangState === 'ru' ? 'Соцсети' : 'Social networks'} isOpened={false}>
            <Socials />
          </Block>

          <Block title={langConfig.activeLangState === 'ru' ? 'Шапка сайта' : 'Header'} isOpened={false}>
            <ul className="setting-options">
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Показывать шапку' : 'Display header'}
                  value={styles.header.isHeaderVisible} 
                  handleChange={(e: boolean) => handleStyleUpdate(e, 'header', 'isHeaderVisible')}
                />
                <div className="radio">
                  <label>
                    <input type="radio" value="default" checked={styles.header.bgBehavior === 'default'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateHeaderBgBehavior(e.target.value)} />
                    {langConfig.activeLangState === 'ru' ? 'Стандартное поведение' : 'Standard behavior'}
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input type="radio" value="visible" checked={styles.header.bgBehavior === 'visible'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateHeaderBgBehavior(e.target.value)} />
                    {langConfig.activeLangState === 'ru' ? 'Всегда закрашена' : 'Always colored'}
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input type="radio" value="transparent" checked={styles.header.bgBehavior === 'transparent'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateHeaderBgBehavior(e.target.value)} />
                    {langConfig.activeLangState === 'ru' ? 'Всегда прозрачная' : 'Always transparent'}
                  </label>
                </div>
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет шапки' : 'Header background color'}
                  icon="paint"
                  colorType="rgb"
                  hex={styles.colors.header}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'header')}
                />
              </li>
              <li style={{marginTop: 24+'px', marginBottom: 0}}>
                <b>{langConfig.activeLangState === 'ru' ? 'Стили для первой кнопки' : 'First button styles'}</b>
              </li>
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать прозрачную кнопку' : 'Transparent button'}
                  value={styles.header.firstButtonOpacity > 0 ? false : true} 
                  handleChange={(e: boolean) => handleStyleUpdate(!e ? 1 : 0, 'header', 'firstButtonOpacity')}
                />
              </li>
              <li style={{marginTop: -16+'px'}}>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать градиент' : 'Use gradient'}
                  value={styles.header.firstButtonGradientActive > 0 ? true : false} 
                  handleChange={(e: boolean) => handleStyleUpdate(e ? 1 : 0, 'header', 'firstButtonGradientActive')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет первой кнопки' : 'Background color of first button'}
                  icon="paint"
                  colorType="rgb"
                  hex={styles.header.firstButtonColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'firstButtonColor')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет шрифта' : 'Font color'}
                  icon="paint"
                  hex={styles.header.firstButtonFontColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'firstButtonFontColor')}
                />
              </li>
              <li style={{marginTop: 24+'px', marginBottom: 0}}>
                <b>{langConfig.activeLangState === 'ru' ? 'Стили для второй кнопки' : 'Second button styles'}</b>
              </li>
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать прозрачную кнопку' : 'Transparent button'}
                  value={styles.header.secondButtonOpacity > 0 ? false : true} 
                  handleChange={(e: boolean) => handleStyleUpdate(!e ? 1 : 0, 'header', 'secondButtonOpacity')}
                />
              </li>
              <li style={{marginTop: -16+'px'}}>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать градиент' : 'Use gradient'}
                  value={styles.header.secondButtonGradientActive > 0 ? true : false} 
                  handleChange={(e: boolean) => handleStyleUpdate(e ? 1 : 0, 'header', 'secondButtonGradientActive')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет второй кнопки' : 'Background color of second button'}
                  icon="paint"
                  colorType="rgb"
                  hex={styles.header.secondButtonColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'secondButtonColor')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет шрифта' : 'Font color'}
                  icon="paint"
                  hex={styles.header.secondButtonFontColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'secondButtonFontColor')}
                />
              </li>
              
              <li style={{marginTop: 24+'px', marginBottom: 0}}>
                <b>{langConfig.activeLangState === 'ru' ? 'Стили для третьей кнопки' : 'Third button styles'}</b>
              </li>
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать прозрачную кнопку' : 'Transparent button'}
                  value={styles.header.thirdButtonOpacity > 0 ? false : true} 
                  handleChange={(e: boolean) => handleStyleUpdate(!e ? 1 : 0, 'header', 'thirdButtonOpacity')}
                />
              </li>
              <li style={{marginTop: -16+'px'}}>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Использовать градиент' : 'Use gradient'}
                  value={styles.header.thirdButtonGradientActive > 0 ? true : false} 
                  handleChange={(e: boolean) => handleStyleUpdate(e ? 1 : 0, 'header', 'thirdButtonGradientActive')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет третьей кнопки' : 'Background color of third button'}
                  icon="paint"
                  colorType="rgb"
                  hex={styles.header.thirdButtonColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'thirdButtonColor')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет шрифта' : 'Font color'}
                  icon="paint"
                  hex={styles.header.thirdButtonFontColor}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'header', 'thirdButtonFontColor')}
                />
              </li>
            </ul>
          </Block>
          
          <Block title={langConfig.activeLangState === 'ru' ? 'Подвал сайта' : 'Footer'} isOpened={false}>
            <ul className="setting-options">
              <li>
                <Checkbox
                  label={langConfig.activeLangState === 'ru' ? 'Показывать подвал' : 'Display footer'}
                  value={styles.footer.isFooterVisible} 
                  handleChange={(e: boolean) => handleStyleUpdate(e, 'footer', 'isFooterVisible')}
                />
              </li>
              <li>
                <Input
                  aside="color"
                  label={langConfig.activeLangState === 'ru' ? 'Цвет подвала' : 'Footer color'}
                  icon="paint"
                  hex={styles.colors.footer}
                  handleChange={(e: string): void => handleStyleUpdate(e, 'colors', 'footer')}
                />
              </li>
            </ul>
          </Block>

          <Block title={langConfig.activeLangState === 'ru' ? 'Блоки' : 'Sections'}>
            <SectionsDnd />
          </Block>

          <Block title={langConfig.activeLangState === 'ru' ? 'Прелоудер' : 'Preloader'} isOpened={false}>
            <ul className="setting-options" style={{ position: 'relative' }}>
              <div style={{ filter: isPrelShown ? 'blur(5px)' : '' }}>
                <li>
                  <Input
                    aside="color"
                    label={langConfig.activeLangState === 'ru' ? 'Цвет' : 'Сolor'}
                    icon="paint"
                    hex={styles.preloader.color}
                    handleChange={(e: string): void => handleStyleUpdate(e, 'preloader', 'color')}
                  />
                </li>
                <li>
                  <Input
                    label={langConfig.activeLangState === 'ru' ? 'Размер' : 'Size'}
                    value={styles.preloader.size}
                    handleChange={(e: string): void => handleStyleUpdate(e, 'preloader', 'size')}
                  />
                </li>
                <li>
                  <Input
                    label={langConfig.activeLangState === 'ru' ? 'Толщина линии' : 'Preloader thickness'}
                    value={styles.preloader.thickness}
                    handleChange={(e: string): void => handleStyleUpdate(e, 'preloader', 'thickness')}
                  />
                </li>
                <li>
                  <Input
                    label={
                      langConfig.activeLangState === 'ru'
                        ? 'Скорость вращения (обороты/сек)'
                        : 'Preloader speed (turns/sec)'
                    }
                    value={styles.preloader.speed}
                    handleChange={(e: string): void => handleStyleUpdate(e, 'preloader', 'speed')}
                  />
                </li>
              </div>
              {isPrelShown && <Preloader styles={styles} />}
              <button onClick={handlePrelShow} type="button" style={{ borderRadius: '4px', padding: '4px 8px' }}>
                {isPrelShown ? 'Скрыть' : 'Показать'}
              </button>
            </ul>
          </Block>
        </div>
      </div>
    </>
  );
};

export default Settings;
